import script from "./DivisionesMotovehiculoPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./DivisionesMotovehiculoPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./DivisionesMotovehiculoPrivadoView.vue?vue&type=style&index=0&id=5c9e5a4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9e5a4f"]])

export default __exports__